import styled from '@emotion/styled';

export const CaseStudyContentWrapper = styled.div`
  background: ${({ theme }) => theme.colors.secondary.white};
  padding: 2rem;
  margin-top: 30px;
  max-width: 1024px;
  margin: auto;
  font-size: 18px;
`;
